import { DatabaseId } from "../helpers/Id";
import { ImportType } from "../models/ImportType";
import { TransactionType, TransactionTagType } from "../models/TransactionBase";

export type ImportFilter =
  | {
      _id: DatabaseId;
      type?: never;
    }
  | { _id?: never; type: ImportType };

export type GetGroupsFilter = {
  transactionType?: TransactionType[];
  ledgerType?: TransactionTagType[];
  dataSource?: string[];
  asset?: string[];
  status?: StatusOption[];
  datePeriod?: Date[];
  searchQuery?: string;
  imports?: ImportFilter[];
};

export type GetGroupsRequestQuery = {
  limit?: number;
  start?: number;
  sort?: TransactionSortOption;
} & GetGroupsFilter;

export enum StatusOption {
  NeedsReview = "NeedsReview",
}

export enum TransactionSortOption {
  DateAscending = "DateAscending",
  DateDescending = "DateDescending",
}
